import { setCookie, deleteCookie } from 'cookies-next/client';
import { type NextResponse } from 'next/server';

// These functions are used to set various cookies that are used as Google Tag Manager variables.
// res? is an optional parameter to allow us to call this function from the middleware file.

export function setGTMCookies({
  cookieRecord,
  res,
}: {
  cookieRecord: Record<string, string>;
  res?: NextResponse;
}): void {
  if (res) {
    Object.entries(cookieRecord).forEach(([key, value]) =>
      res.cookies.set(key, value, { secure: true })
    );
  } else {
    Object.entries(cookieRecord).forEach(([key, value]) =>
      setCookie(key, value, { secure: true })
    );
  }
}

export function deleteGTMCookies({
  cookieKeyList,
  res,
}: {
  cookieKeyList: string[];
  res?: NextResponse;
}) {
  if (res) {
    cookieKeyList.forEach((cookieKey) =>
      res.cookies.delete({ name: cookieKey, secure: true })
    );
  } else {
    cookieKeyList.forEach((cookieKey) => deleteCookie(cookieKey));
  }
}
